import type { Profile } from "./_type";

import { useMemo } from "react";

import { useGet } from "~/common/hooks";

/** useGetProfileAgent */
export const useGetProfileAgent = (external_user: string, enabled: boolean) => {
  /** URL */
  const url = useMemo(
    () => `/agents/profile/${external_user}`,
    [external_user]
  );

  /** return */
  return useGet<Profile>(url, undefined, { enabled });
};
